const en = {
  placeholder: {
    title: 'Crew Crisis',
    tagline: 'Something went wrong on the trip. Work together to get your crew home.',
    narrator: 'Mission Control',
    status: 'Signal weak',
    message1: 'Crew, do you read me? This is Mission Control.',
    message2: "We're still putting the ship back together. Hold tight.",
    message3: 'Launch window opens soon. Keep your phones close.',
    typing: 'Mission Control is typing',
  },
  notFound: {
    title: 'Lost in space',
    body: 'This page drifted off course.',
  },
  error: {
    title: 'Houston, we have a problem',
    body: 'Something broke on our side. Try again in a moment.',
  },
  backToBase: 'Back to base',
};

export default en;
